export default function merchantImagesService($http, RESOURCES, API_V2_HEADER) {
  var imagesUrl = '/images';

  function getImages(id) {
    return $http.get(RESOURCES.MERCHANT + '/' + id + imagesUrl);
  }

  function deleteImage(merchantId, imageId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + imagesUrl + '/' + imageId);
  }

  function updateSortOrder(merchantId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + imagesUrl + '/sort_order', data);
  }

  function uploadImage(merchantId, imageData, file) {
    var fd = new FormData();
    fd.append('imageDto', new Blob([angular.toJson(imageData)], { type: 'application/json' }));
    fd.append('attachment', file);

    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + imagesUrl, fd, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined },
    });
  }

  function uploadImages(merchantId, data) {
    return $http.post(RESOURCES.MERCHANT + '/' + merchantId + imagesUrl, data, {
      headers: API_V2_HEADER.headers,
    });
  }

  return {
    getImages: getImages,
    updateSortOrder: updateSortOrder,
    deleteImage: deleteImage,
    uploadImage: uploadImage,
    uploadImages: uploadImages,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/images/images.service.js